import { render } from "./ParamPortForm.vue?vue&type=template&id=5f6d1f94&ts=true"
import script from "./ParamPortForm.vue?vue&type=script&lang=ts"
export * from "./ParamPortForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__